import window from 'window';
import { debounce } from '../../utilities/debounce';
import { scroller } from '../../utilities/scroller';

export const cardsPagination = () => {
    const cardsPerPage = {
        0: 9,
        768: 6,
        1024: 9,
    };
    let currentPage = 1;
    let cards = null;
    let button = null;
    const selectors = {
        button: '.offer-module__button',   
        card: '.offer-card',     
    };

    const _updateVisibleCards =  (scroll=true)=> {
        const windowWidth = window.innerWidth;
        const breakpoints = Object.entries(cardsPerPage).filter(([width, total]) => windowWidth >= width && total );
        const perPage = breakpoints[breakpoints.length - 1][1];
        if (!cards) return;
        const cardsToShow = perPage * currentPage;
        const cardsShown = currentPage > 1 ? perPage * ( currentPage - 1 ) : perPage;
        const firstCard = cards[cardsShown];
        cards.forEach((card, i) => {
            const parent = card.parentElement;
            parent.setAttribute('style', 'display: block;');
            if(i > cardsToShow - 1 ) {
                parent.setAttribute('style', 'display: none;');
            }
        });
        const display = cardsToShow < cards.length ? 'block' : 'none';
        if(button) {
            button.setAttribute('style', `display: ${display};` )
        }
        if(scroll) {
            scroller.scrollToElement(firstCard, () => {
                button.removeAttribute('disabled');
            });
        } 
    };

    const _handleClick = e => {
        e.preventDefault();
        currentPage += 1;
        
        _updateVisibleCards();
    }

    const init = component => {
        if(component) {
            cards = component.querySelectorAll(selectors.card);
            button = component.querySelector(selectors.button);
            _updateVisibleCards(false);
            window.addEventListener('resize', debounce(() => {
                _updateVisibleCards(false);
            }), 250);  
            if(button) {
                button.addEventListener('click', e => _handleClick(e));
            } 
        }
    };

    return {
        init: init,
        selector: '[data-component="used-offer-module"]'
    };
};